export const isDev: boolean = process.env.ENVIRONMENT === 'DEV'

export const appConfig = {
  apiUrl: process.env.API_BASE_URL,
  storageKey: process.env.STORAGE_KEY
}
